import { isMobile, isTablet } from 'react-device-detect';
import styled from 'styled-components';

export const InfoWrapper = styled.div`
	background: linear-gradient(108.78deg, #331c46 0.39%, #250b39 100%);
	position: absolute;
	width: ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(${p.dimentions.width}px * 0.58)`
			: '100%'};
	height: ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(${p.dimentions.height}px * 0.61)`
			: '100dvh'};
	left: ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(${p.dimentions.x}px + 70px * ${p.dimentions.scale})`
			: 0};
	transform: ${!isMobile && !isTablet ? 'translateX(8%)' : 'translateX(0%)'};
	top: ${(p) => (p.y && !isMobile && !isTablet ? p.y + 'px' : 0)};
	opacity: 0.9;
	border-radius: ${(p) =>
		p.dimentions && `calc(${p.dimentions.width}px * 0.01)`};
	animation: appear 0.2s linear;
	transform-origin: center;
	font-size: ${(p) => p.dimentions && `calc(${p.dimentions.scale} * 24px)`};
	user-select: none;
	touch-action: none;
	@keyframes appear {
		0% {
			/* transform: translateY(-100%); */
			opacity: 0;
		}
		100% {
			/* transform: translateY(0%); */
			opacity: 1;
		}
	}
`;

export const InfoBox = styled.div`
	height: ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(100% - (${p.dimentions.scale} * 120px))`
			: '90%'};
	margin-top: 2vh;
	/* margin-top:  ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(${p.dimentions.scale} * 20px)`
			: '1%'}; */
	overflow-x: hidden;
	overflow-y: scroll;
	border-bottom-right-radius: ${(p) =>
		p.dimentions && `calc(${p.dimentions.width}px * 0.01)`};
	border-bottom-left-radius: ${(p) =>
		p.dimentions && `calc(${p.dimentions.width}px * 0.01)`};
	margin-right: ${(p) =>
		p.dimentions && !isMobile && !isTablet
			? `calc(${p.dimentions.scale} * 2vh)`
			: '1%'};
	&&::-webkit-scrollbar {
		width: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 17px)`
				: '0'};
		background-color: #250b39;
		border-radius: 11px;
	}
	&&::-webkit-scrollbar-thumb {
		background-color: #9973b6;
		border-radius: 11px;
	}
	&&::-webkit-scrollbar-thumb:hover {
		background-color: #d6c7e2;
	}
	&&::-webkit-scrollbar-track {
		background-color: #1f0b31;
		border-radius: 11px;
	}
`;

export const InfoHeader = styled.div`
	border-top-left-radius: ${(p) =>
		p.dimentions && `calc(${p.dimentions.width}px * 0.01)`};
	border-top-right-radius: ${(p) =>
		p.dimentions && `calc(${p.dimentions.width}px * 0.01)`};
	background: linear-gradient(108.78deg, #331c46 0.39%, #250b39 100%);
	box-shadow: 0px
		${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * -2px)`
				: '-2px'}
		0px 0px #ffffff14 inset;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.close-btn {
		width: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 40px)`
				: '49px'};
		height: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 40px)`
				: '40px'};
		margin: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 1.8vh)`
				: '18px'};
		/* max-width: 40px;
		max-height: 40px; */
		cursor: pointer;
		:hover {
			opacity: 0.5;
		}
	}
`;
export const Title = styled.div`
	flex-grow: ${!isMobile && !isTablet ? 1 : 0};
	text-align: ${!isMobile && !isTablet ? `center` : 'left'};
	svg {
		width: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 300px)`
				: '60%'};
		height: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 70px)`
				: '100%'};
		max-width: 300px;
		max-height: 70px;
		margin-left: ${(p) =>
			p.dimentions && !isMobile && !isTablet
				? `calc(${p.dimentions.scale} * 6vh)`
				: '0'};
	}
`;

export const Close = styled.div``;
